import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=21d23b15&"
import script from "./Tax.vue?vue&type=script&lang=js&"
export * from "./Tax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d23b15')) {
      api.createRecord('21d23b15', component.options)
    } else {
      api.reload('21d23b15', component.options)
    }
    module.hot.accept("./Tax.vue?vue&type=template&id=21d23b15&", function () {
      api.rerender('21d23b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Tax.vue"
export default component.exports